import { defineMessages } from 'react-intl';
import type { IntlShape } from 'react-intl';

const messages = defineMessages({
  section: {
    id: 'Section',
    defaultMessage: 'Section',
  },
  heading: {
    id: 'Heading',
    defaultMessage: 'Heading',
  },
  color: {
    id: 'section.color',
    defaultMessage: 'Background',
  },
  colorBrand: {
    id: 'section.color.brand',
    defaultMessage: 'Brand (teal)',
  },
  colorSubtle: {
    id: 'section.color.subtle',
    defaultMessage: 'Subtle (light gray)',
  },
  colorNone: {
    id: 'section.color.none',
    defaultMessage: 'None',
  },
  width: {
    id: 'section.width',
    defaultMessage: 'Content width',
  },
  flushBottom: {
    id: 'section.flushBottom',
    defaultMessage: 'Flush bottom (no bottom padding)',
  },
});

/**
 * Schema do bloco Section (container vertical com faixa de cor).
 * Cores são tokens SEMÂNTICOS (brand/subtle), não nomes de cor —
 * ver docs/specs/blocks/section.md §4.1.
 *
 * `heading` é o título da faixa (About, Latest News). É campo do bloco, e não
 * um bloco slate solto lá dentro, para o título ter estilo próprio e igual em
 * toda seção — como já era no iconCards. Ver docs/specs/blocks/section.md §4.4.
 */
const SectionSchema = ({ intl }: { intl: IntlShape }) => ({
  title: intl.formatMessage(messages.section),
  block: 'section',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['heading', 'color', 'width', 'flushBottom'],
    },
  ],
  properties: {
    heading: {
      title: intl.formatMessage(messages.heading),
      type: 'string',
    },
    color: {
      title: intl.formatMessage(messages.color),
      choices: [
        ['brand', intl.formatMessage(messages.colorBrand)],
        ['subtle', intl.formatMessage(messages.colorSubtle)],
        ['none', intl.formatMessage(messages.colorNone)],
      ],
      default: 'brand',
    },
    width: {
      title: intl.formatMessage(messages.width),
      choices: [
        ['default', 'Default'],
        ['narrow', 'Narrow'],
        ['full', 'Full'],
      ],
      default: 'default',
    },
    flushBottom: {
      title: intl.formatMessage(messages.flushBottom),
      type: 'boolean',
      default: false,
    },
  },
  required: [],
});

export default SectionSchema;
